module.exports = {
	"description": "Document if there is a history of violence and any specific behaviours (that may indicate a risk of violence) that will require specific care interventions. Score 1 for a history of violence and 1 for each behaviour observed.",
	"label": "A",
	"subsections": [
		{
			"behaviours": {
				"history": {
					"text": "Past occurrence of",
					"points": [
						"Exercising physical force, in any setting, towards any person including a caregiver that caused or could have caused injury",
						"Attempting to exercise physical force, in any setting, towards any person including a caregiver that could cause injury",
						"Statement or behaviours that could reasonably be interpreted as threatening to exercise physical force, in any setting, against any person including a caregiver that could cause injury"
					],
					"checked": false
				}
			},
			"comments": null,
			"title": "History of Violence"
		},
		{
			"behaviours": {
				"confused": {
					"text": "Confused",
					"points": [
						"Disoriented – e.g., unware of time, place, or person"
					],
					"checked": false
				},
				"irritable": {
					"text": "Irritable",
					"points": [
						"Easily annoyed or angered",
						"Unable to tolerate the presence of others",
						"Unwilling to follow instructions"
					],
					"checked": false
				},
				"boisterous": {
					"text": "Boisterous",
					"points": [
						"Overtly loud or noisy – e.g., slamming doors, shouting etc."
					],
					"checked": false
				},
				"verbal": {
					"text": "Verbal Threats",
					"points": [
						"Raises voice in an intimidating or threatening way",
						"Shouts angrily, insulting others or swearing",
						"Makes aggressive sounds"
					],
					"checked": false
				},
				"physical": {
					"text": "Physical Threats",
					"points": [
						"Raises arms / legs in an aggressive or agitated way",
						"Makes a fist",
						"Makes an aggressive stance",
						"Moves / lunges forcefully towards others"
					],
					"checked": false
				},
				"objects": {
					"text": "Attacking Objects",
					"points": [
						"Kicks objects",
						"Smashes furniture"
					],
					"checked": false
				},
				"agitated": {
					"text": "Agitated / Impulsive",
					"points": [
						"Unable to remain composed",
						"Quick to overreact to real and imagined disappointments",
						"Troubled, nervous, restless or upset",
						"Spontaneous, hasty, or emotional"
					],
					"checked": false
				},
				"paranoid": {
					"text": "Paranoid / Suspicious",
					"points": [
						"Unreasonably or obsessively anxious",
						"Overly suspicious or mistrustful – e.g., belief of being spied on or someone conspiring to hurt them"
					],
					"checked": false
				},
				"substance": {
					"text": "Substance Intoxication / Withdrawal",
					"points": [
						"Intoxicated or in withdrawal from alcohol or drugs"
					],
					"checked": false
				},
				"disruptive": {
					"text": "Socially Inappropriate / Disruptive Behaviour",
					"points": [
						"Makes disruptive noises",
						"Screams",
						"Engages in self-abusive acts, sexual behaviour or inappropriate behaviour – e.g., hoarding, smearing feces / food, etc."
					],
					"checked": false
				},
				"body": {
					"text": "Body Language",
					"points": [
						"Torso shield – arms / objects acting as a barrier",
						"Puffed up chest – territorial dominance",
						"Deep breathing / panting",
						"Arm dominance – arms spread, behind head, on hips",
						"Eyes – pupil dilation / constriction, rapid blinking, gazing",
						"Lips – compression, sneering, blushing / blanching"
					],
					"checked": false
				}
			},
			"comments": null,
			"title": "Observed Behaviours"
		}
	],
	"title": "Risk Indicators"
};


//////////////////
// WEBPACK FOOTER
// ./src/initialStore/riskIndicators.json
// module id = 886
// module chunks = 0